import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileMenuV3Component } from './component/profile-menu-v3/profile-menu-v3.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { DistrictSelectorComponent } from './component/district-selector/district-selector.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { EllipsisTooltipDirective } from './directives/ellipsis.directive';
import { TabPanelRouteComponent } from './component/tab-panel-route/tab-panel-route.component';
import { MatTabsModule } from '@angular/material/tabs';
import { SchoolSelectorComponent } from './component/school-selector/school-selector.component';
import { MatMenuModule } from '@angular/material/menu';
import { ItopiaLoaderComponent } from './component/itopia-loader/itopia-loader.component';
import { DateRangeFilterComponent } from './component/date-range-filter/date-range-filter.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CardGalanceComponent } from './component/card-galance/card-galance.component';
import { MatCardModule } from '@angular/material/card';
import { ChartHistoricalActiveUserComponent } from './component/chart-historical-active-user/chart-historical-active-user.component';
import { ChartsModule } from 'ng2-charts';
import { CustomLinearChartComponent } from './component/custom-linear-chart/custom-linear-chart.component';
import { ClassesSelectorComponent } from './component/classes-selector/classes-selector.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CustomBarChartComponent } from './component/custom-bar-chart/custom-bar-chart.component';
import { TopAppUsageComponent } from './component/top-app-usage/top-app-usage.component';
import { TopSchoolsByHourlyConsumptionComponent } from './component/top-schools-by-hourly-consumption/top-schools-by-hourly-consumption.component';
import { TopSchoolsByActiveStudentsComponent } from './component/top-schools-by-active-students/top-schools-by-active-students.component';
import { ErrorPageV3Component } from './component/error-page-v3/error-page-v3.component';
import { TopStudentsByUsageComponent } from './component/top-students-by-usage/top-students-by-usage.component';
import { TopClassesBySessionsComponent } from './component/top-classes-by-sessions/top-classes-by-sessions.component';
import { TopSchoolsByActiveTeachersComponent } from './component/top-schools-by-active-teachers/top-schools-by-active-teachers.component';
import { TopSchoolsByActiveSessionsComponent } from './component/top-schools-by-sessions/top-schools-by-sessions.component';
import { ResponsiveSvgCardComponent } from './component/responsive-svg-card/responsive-svg-card.component';
import { StudentsEnrolledListComponent } from './component/students-enrolled-list/students-enrolled-list.component';
import { StudentsEnrolledContainerComponent } from './component/students-enrolled-container/students-enrolled-container.component';
import { MatPaginatorOnDemandModule } from 'src/app/shared/components/mat-paginator-on-demand/mat-paginator-on-demand.module';
import {DatatableServerSideModule} from 'src/app/shared/components/datatable-server-side/datatable-server-side.module';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { CustomTimerPickerComponent } from './component/custom-timer-picker/custom-timer-picker.component';
import { ElementClassesSelectorComponent } from './component/element-classes-selector/element-classes-selector.component';
import { StudentListV3Component } from './component/student-list-v3/student-list-v3.component';

@NgModule({
  declarations: [
    ProfileMenuV3Component,
    DistrictSelectorComponent,
    EllipsisTooltipDirective,
    TabPanelRouteComponent,
    SchoolSelectorComponent,
    ItopiaLoaderComponent,
    CardGalanceComponent,
    DateRangeFilterComponent,
    ChartHistoricalActiveUserComponent,
    CustomLinearChartComponent,
    ClassesSelectorComponent,
    CustomBarChartComponent,
    TopAppUsageComponent,
    TopSchoolsByHourlyConsumptionComponent,
    TopSchoolsByActiveStudentsComponent,
    TopSchoolsByActiveTeachersComponent,
    TopSchoolsByActiveSessionsComponent,
    ErrorPageV3Component,
    TopStudentsByUsageComponent,
    TopClassesBySessionsComponent,
    ResponsiveSvgCardComponent,
    StudentsEnrolledListComponent,
    StudentsEnrolledContainerComponent,
    CustomTimerPickerComponent,
    ElementClassesSelectorComponent,
    StudentListV3Component,
  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatIconModule,
    FlexLayoutModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    FormsModule,
    MatToolbarModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatAutocompleteModule,
    MatOptionModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    ChartsModule,
    MatProgressBarModule,
    MatPaginatorOnDemandModule,
    DatatableServerSideModule,
    DirectivesModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatSortModule, 
    MatTableModule
  ],
  exports: [
    ProfileMenuV3Component,
    DistrictSelectorComponent,
    TabPanelRouteComponent,
    SchoolSelectorComponent,
    ItopiaLoaderComponent,
    DateRangeFilterComponent,
    CardGalanceComponent,
    ChartHistoricalActiveUserComponent,
    ClassesSelectorComponent,
    CustomBarChartComponent,
    TopAppUsageComponent,
    TopSchoolsByHourlyConsumptionComponent,
    TopSchoolsByActiveStudentsComponent,
    CustomLinearChartComponent,
    TopSchoolsByActiveTeachersComponent,
    TopSchoolsByActiveSessionsComponent,
    ErrorPageV3Component,
    TopStudentsByUsageComponent,
    TopClassesBySessionsComponent,
    ResponsiveSvgCardComponent,
    StudentsEnrolledListComponent,
    StudentsEnrolledContainerComponent,
    CustomTimerPickerComponent,
    ElementClassesSelectorComponent,
    StudentListV3Component
  ]
})
export class SharedV3Module { }
